import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { AxiosPromise, AxiosRequestConfig } from 'axios';

import { api } from '@/api';

export async function getLookupSuburb(
  params: openapi.AddressBookSuburbLookupListQueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.AddressBookSuburbLookupListContentOpenapi> {
  return await api.get<openapi.AddressBookSuburbLookupListContentOpenapi>(
    '/lookup/suburb/',
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getLookupAddress(
  params: openapi.GetLookupAddress_Query,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.GetLookupAddress_200> {
  return await api.get<openapi.GetLookupAddress_200>('/lookup/address/', {
    ...requestConfig,
    params,
  });
}

export async function getLookupSuburbGnaf(
  params: openapi.AddressBookGnafSuburbLookupListQueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.AddressBookGnafSuburbLookupListContentOpenapi> {
  return await api.get<openapi.AddressBookGnafSuburbLookupListContentOpenapi>(
    '/lookup/suburb-gnaf/',
    {
      ...requestConfig,
      params,
    },
  );
}
